export enum MicrositeBreakpoint {
	SMALL = 'small',
	MEDIUM = 'medium',
	LARGE = 'large',
	XLARGE = 'xlarge',
}

export enum MicrositeTemplate {
	ALPHA = 'ALPHA',
	BETA = 'BETA',
	DELTA = 'DELTA',
	EPSILON = 'EPSILON',
	ETA = 'ETA',
	GAMMA = 'GAMMA',
	ZETA = 'ZETA',
}

interface MicrositeThemeColor {
	fill: string;
	text: {
		strong: string;
		weak: string;
	};
	stroke: {
		strong: string;
		weak: string;
	};
}

export enum MicrositeColor {
	WHITE = 'white',
	BLACK = 'black',
	GREEN = 'green',
	BRAND = 'brand',
	RED = 'red',
}

export interface MicrositeTheme {
	viewport: Record<MicrositeBreakpoint, number>;
	zoom?: number;
	font: {
		family: MicrositeFontFamily;
		spacing: {
			sm: string;
			md: string;
			lg: string;
		};
	};
	gap: {
		grid: string;
		content: string;
		large: string;
		section: string;
	};
	radius: string;
	rail: {
		width: string;
	};
	margin: {
		left: string;
		right: string;
	};
	color: Record<MicrositeColor, MicrositeThemeColor> & {
		stroke: MicrositeColor;
		background: MicrositeColor;
		fill: MicrositeColor;
	};
}

export enum SmoothScrollingMode {
	CSS = 'CSS',
	JS = 'JS',
}

export interface MicrositeConfig {
	theme: MicrositeTheme;
	smooth?: SmoothScrollingMode;
}

export interface MicrositeFontFamily {
	stack: string;
	url: string;
}

export interface MicrositeProfile {
	name: string;
	headshot?: MicrositeResponsiveImage;
	logo?: string;
	organization?: string;
	title?: string;
	company?: string;
	phone?: string;
	email?: string;
	office?: string;
	website?: string;
	domain?: string;
	license?: string;
}

export interface MicrositeListingData {
	mls?: string;
	beds?: number;
	baths?: number;
	built?: number;
	lot?: number;
	lot_acres?: number;
	sqft?: number;
	garage?: number;
	price_formatted?: string;
	body?: string;
}

export interface MicrositeWalkthroughData {
	type: 'matterport' | 'nucleus' | 'iguide';
	url: string;
}

export interface MicrositeVideoData {
	m3u8: string;
	mp4: string;
	thumbnail: MicrositeResponsiveImage;
}

export interface MicrositeResponsiveImage {
	medium_1x: string;
	medium_2x: string;
	large_1x: string;
	large_2x: string;
	small_1x: string;
	small_2x: string;
	small_3x: string;
}

export interface MicrositeAddress {
	line1: string;
	line2: string | null;
	city: string;
	state: string;
	zip: string;
	long: number;
	lat: number;
}
